const IdTypeEnum = {
  DrivesLicense: { value: 'D', name: 'Drivers License' },
  MilitaryID: { value: 'M', name: 'Military ID' },
  Passport: { value: 'P', name: 'Passport' },
  StateIssuedID: { value: 'S', name: 'State Issued ID' },
};

export default IdTypeEnum;
